module.exports = __webpack_public_path__ + "static/img/smartControl22.ec917c57.jpg";